"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IJobReleaseToMarketplaceStrategy = exports.IJobReleaseAudience = exports.JobStatusEnum = void 0;
var JobStatusEnum;
(function (JobStatusEnum) {
    JobStatusEnum["Active"] = "active";
    JobStatusEnum["Canceled"] = "canceled";
    JobStatusEnum["Completed"] = "completed";
    JobStatusEnum["Unfilled"] = "unfilled";
    JobStatusEnum["ClockedIn"] = "clocked_in";
    JobStatusEnum["ClockedOut"] = "clocked_out";
    JobStatusEnum["NoShow"] = "no_show";
    JobStatusEnum["Booked"] = "booked";
    JobStatusEnum["LateCancellation"] = "late_cancellation";
    JobStatusEnum["Void"] = "void";
    JobStatusEnum["Disputed"] = "disputed";
    JobStatusEnum["CanceledWithFee"] = "canceled_with_fee";
    JobStatusEnum["MissedShift"] = "missed_shift";
    JobStatusEnum["Unavailable"] = "unavailable";
    JobStatusEnum["Draft"] = "draft";
    JobStatusEnum["HeldForDisputeReview"] = "held_for_dispute_review";
})(JobStatusEnum = exports.JobStatusEnum || (exports.JobStatusEnum = {}));
var IJobReleaseAudience;
(function (IJobReleaseAudience) {
    IJobReleaseAudience["Both"] = "both";
    IJobReleaseAudience["Saas"] = "saas";
    IJobReleaseAudience["Marketplace"] = "marketplace";
})(IJobReleaseAudience = exports.IJobReleaseAudience || (exports.IJobReleaseAudience = {}));
var IJobReleaseToMarketplaceStrategy;
(function (IJobReleaseToMarketplaceStrategy) {
    IJobReleaseToMarketplaceStrategy["Instant"] = "instant";
    IJobReleaseToMarketplaceStrategy["Never"] = "never";
    IJobReleaseToMarketplaceStrategy["TwentyFourHoursBeforeStartsTime"] = "twenty_four_hours_before_starts_time";
})(IJobReleaseToMarketplaceStrategy = exports.IJobReleaseToMarketplaceStrategy || (exports.IJobReleaseToMarketplaceStrategy = {}));
